/**
 * Zentrale App-Konfiguration – die einzige Quelle der Wahrheit für globale
 * Einstellungen. App-Name und Backend-URL werden überall im Code von hier
 * herangezogen (kein .env nötig).
 */
export const config = {
  /** Anzeigename der App: Titel, Branding, Login – alles zieht diesen Wert. */
  appName: "Lernapp",

  /**
   * URL des PocketBase-Backends.
   *
   *   >>> HIER die URL deines Hosters eintragen <<<
   *
   * Beispiele:
   *   "https://pb.deinedomain.de"
   *   "http://123.45.67.89:8090"
   */
  // pocketbaseUrl: "https://mfw2trsqa3ahau6.ba7w.pocketbasecloud.com/",
  pocketbaseUrl: "https://mitschrift-db.kendrick-setzer.de/",

  /**
   * KI-Konfiguration. Anbieter ist OpenRouter: kostenlose ":free"-Modelle,
   * OpenAI-kompatible Schnittstelle. Ohne Guthaben 50 Anfragen/Tag, ab 10 $
   * einmalig aufgeladen 1000/Tag – der Server drosselt sich zusätzlich
   * selbst auf OPENROUTER_DAILY_LIMIT (Default 100), um sparsam zu bleiben.
   *
   * Schlüssel holen: https://openrouter.ai/keys
   *
   * Woher der Schlüssel kommt, in dieser Reihenfolge (siehe ai.service.ts):
   *   1. `apiKey` hier   – nur zum lokalen Entwickeln, umgeht PocketBase
   *   2. PocketBase-Hook – POST /api/ai/chat (pb_hooks/hooks.pb.js),
   *                        Env-Variable OPENROUTER_API_KEY, Schlüssel bleibt
   *                        serverseitig; das Frontend braucht dafür nur
   *                        eine eingeloggte Sitzung, keinen eigenen Schlüssel
   *
   * Transkription (Sprache -> Text) läuft weiter über Groq/Whisper (Env
   * GROQ_API_KEY im Hook) – OpenRouter hat keine Audio-Schnittstelle.
   *
   * PRODUKTION: `apiKey` leer lassen. Was hier steht, landet im Bundle und
   * ist für jeden Nutzer lesbar – und damit auf deine Rechnung nutzbar.
   */
  ai: {
    apiKey: "", // leer = Anfragen laufen über den PocketBase-Hook (Backend-Proxy)
    baseUrl: "https://openrouter.ai/api/v1",
    modelSmall: "nvidia/nemotron-3.5-lightning:free ",       // schnelle/einfache Aufgaben
    modelMedium: "nvidia/nemotron-3.5-lightning:free", // Klausur, Benotung, anspruchsvoll

    /**
     * Ausweichanbieter, der Reihe nach versucht, wenn der erste nicht kann
     * (Zeitüberschreitung, Kontingent erschöpft, Serverfehler). Alle
     * sprechen dieselbe OpenAI-Schnittstelle, es braucht also nur Adresse,
     * Schlüssel und Modellnamen – keinen Code.
     *
     * Weitere kostenlose Kandidaten (Schlüssel ohne Kreditkarte):
     *   Google  baseUrl "https://generativelanguage.googleapis.com/v1beta/openai"
     *           modelSmall/Medium "gemini-2.5-flash"
     *   Mistral baseUrl "https://api.mistral.ai/v1"
     *           modelSmall "mistral-small-latest"
     */
    fallbacks: [] as { baseUrl: string; apiKey: string; modelSmall: string; modelMedium: string }[],
  },
} as const;

export type AppConfig = typeof config;


